import ScrollObserverRootContext from '../../contexts/ScrollObserverContext/ScrollObserverRootContext';
import { defaultContextValue } from '../../utils/scrollObserver';

import type { PropsWithChildren } from 'react';
import type { ScrollObserverRootContextState } from './types';

type ScrollObserverRootContextProviderProps = PropsWithChildren<ScrollObserverRootContextState>;

const ScrollObserverRootContextProvider = (props: ScrollObserverRootContextProviderProps) => {
  const { children, ...state } = props;

  return (
    <ScrollObserverRootContext.Provider
      value={{
        ...defaultContextValue,
        ...state,
      }}
    >
      {children}
    </ScrollObserverRootContext.Provider>
  );
};

export default ScrollObserverRootContextProvider;
